<template>
	<div class="errorpage">
		<CommonHead></CommonHead>
		<b-container>
			<h1>Sorry, this page cannot be found.</h1>
			<div class="error-opt">
				<div class="menuopt">
					<h2>Fabric</h2>
					<ul>
						<li><a href="/shop/products/fabric">View All Fabric</a></li>
						<li><a href="/lining">Lining</a></li>
						<li><a href="/fabric-brands/">View Brands</a></li>
						<li><a href="/shop/collections/fabric?items=20&amp;sort=newest&amp;page=1">View Collections</a></li>
						<li><a href="/shop/products/sample?type=Fabric%20Samples">Order Samples</a></li>
						<li><a href="/textile-finish-glossary/">Textile Finish  Glossary</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Trimming</h2>
					<ul>
						<li><a href="/shop/products/trim">View all Trimming</a></li>
						<li><a href="/shop/collections/trim?items=20&amp;sort=newest&amp;page=1">View Collections</a></li>
						<li><a href="/shop/products/sample?type=Trim%20Samples">Order Samples</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Hardware</h2>
					<ul>
						<li><a href="/hardware-brands">View Brands</a></li>
						<li><a href="/hardware-resources">Hardware Resources</a></li>
						<li><a href="/shop/products/sample?type=Hardware%20Samples">Order Samples</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Resources</h2>
					<ul>
						<li><a href="/customer-resources/#pricelist">Price Lists</a></li>
						<li><a href="/customer-resources/#workroom">Workroom</a></li>
						<li><a href="/customer-resources/#furnishings">Furnishings</a></li>
						<li><a href="/customer-resources/#forms">Forms</a></li>
						<li><a href="/customer-resources/#hardware">Hardware</a></li>
						<li><a href="/customer-resources/#image">Images</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Furnishings</h2>
					<ul>
						<li><a href="/furnishing/">View All Furnishings</a></li>
						<li><a href="/shop/products/sample?type=Furniture%20Samples">Order Samples</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Workroom</h2>
					<ul>
						<li><a href="/workroom">About Workroom</a></li>
						<li><a href="/draperies">Draperies</a></li>
						<li><a href="/roman-shades">Roman Shades</a></li>
						<li><a href="/customer-resources/#workroom">Workroom Resources</a></li>
						<li><a href="/top-treatment/">Top Treatments</a></li>
						<li><a href="/bedding/">Bedding</a></li>
						<li><a href="/accents/">Accents</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Account</h2>
					<ul>
						<li><a href="/shop/login">Sign In</a></li>
						<li><a href="/apply/">Request Account</a></li>
					</ul>
				</div>
				<div class="menuopt">
					<h2>Get Help</h2>
					<ul>
						<li><a href="#">1-800-325-8025</a></li>
						<li><a href="mailto:customerservice@rmcoco.com">customerservice@rmcoco.com</a></li>
					</ul>
				</div>
			</div>
		</b-container>
		<CommonFoot></CommonFoot>
	</div>
</template>

<script>
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
export default {
    components: {
        CommonHead,
		CommonFoot
    },
	metaInfo: {
		title: 'RM COCO | 404 Page not found',
	},
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>
<style>
.errorpage h1{
	margin-top:50px;
}
.error-opt{
	display: flex;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 70px auto 0 auto;
}
.error-opt .menuopt{
	width:25%;
	margin-bottom:50px;
}
.error-opt .menuopt h2{
	text-align:left;
	margin-bottom:20px;
	line-height:normal;
}
.error-opt .menuopt ul li{
	width:100%;
	margin-bottom:10px;
}
.error-opt .menuopt ul li a{
	width:100%;
	display:inline-block;
	font-weight:normal;
	font-size:14px;
	color:#303030;
	line-height: 22px;
    width: auto;
    border-bottom: 1px solid #ffffff;
	text-decoration:none;
}
.error-opt .menuopt ul li a:hover{
	border-bottom:1px solid #303030;
	text-decoration:none;
}
@media only screen and (max-width:767px){
	.error-opt{
		width: 100%;
	}
}
</style>
